import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface GlowingOrbProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  color?: "primary" | "secondary" | "accent";
  animate?: boolean;
}

const sizeClasses = {
  sm: "w-32 h-32",
  md: "w-64 h-64",
  lg: "w-96 h-96",
  xl: "w-[32rem] h-[32rem]",
};

const colorClasses = {
  primary: "bg-primary/20",
  secondary: "bg-secondary/30",
  accent: "bg-accent/25",
};

export function GlowingOrb({
  className,
  size = "md",
  color = "primary",
  animate = true,
}: GlowingOrbProps) {
  return (
    <motion.div
      className={cn(
        "rounded-full blur-3xl pointer-events-none",
        sizeClasses[size],
        colorClasses[color],
        className
      )}
      animate={
        animate
          ? {
              scale: [1, 1.1, 1],
              opacity: [0.3, 0.5, 0.3],
            }
          : {}
      }
      transition={{
        duration: 12, // Increased for less CPU usage
        repeat: Infinity,
        ease: "easeInOut",
      }}
      style={{ willChange: 'transform, opacity' }}
    />
  );
}

interface FloatingShapesProps {
  className?: string;
}

export function FloatingShapes({ className }: FloatingShapesProps) {
  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {/* Use CSS animations instead of Framer Motion for better performance */}
      <div
        className="absolute top-1/4 -left-20 w-40 h-40 bg-primary/10 rounded-full blur-3xl animate-float-slow"
        style={{ willChange: 'transform' }}
      />
      <div
        className="absolute top-1/2 -right-20 w-60 h-60 bg-primary/5 rounded-full blur-3xl animate-float-slower"
        style={{ willChange: 'transform', animationDelay: '1s' }}
      />
      <div
        className="absolute bottom-1/4 left-1/3 w-32 h-32 bg-primary/10 rounded-full blur-3xl animate-float-slow"
        style={{ willChange: 'transform', animationDelay: '2s' }}
      />
    </div>
  );
}
